<template>
    <div>
        <div class="budget__card--B2B">
            <div class="card--budget d-flex justify-center align-center" @click="$emit('card-clicked');">
                <div class="card--icon">
                    <img :src="configCard.icon" :alt="$t('module-budget.cards.budget')" onload="SVGInject(this)" width="80" height="80"/>
                </div>
                <div class="card--texts">
                    <h5 v-if="configCard.title">{{ configCard.title }}</h5>
                    <h3 v-if="configCard.subtitle">{{ configCard.subtitle }}</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        configCard: Array | Object

    },
    data(){
        return{

        }
    },

    methods: {
        redirectLink(url) {
            this.$router.push(url);
        },

    }
};
</script>


<style lang="scss">
@import '@sass/_variables.scss';

$padding-default: 15px;

.budget__card--B2B {
    .card--budget {
        display: flex;
        font-family: Lato;
        height: 151px;

        background-color: $white;
        border-radius: 10px;
        padding: 35px 50px;
        box-shadow: 0px 4px 20px $dark;
        transition: $animations-time-duration ease;
        cursor: pointer;
        border-left: 10px solid #9E9D9D;
        box-shadow: 0px 2px 6px rgb(0 0 0 / 6%);
        -moz-box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.06);
        -o-box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.06);
        -webkit-box-shadow: 0px 2px 6px rgb(0 0 0 / 6%);

        .card--icon {
            width: 80px;
            height: 80px;
            min-width: 80px;
            min-height: 80px;
            margin-right: 20px;
        }

        .card--texts {
            h5 {
                font-size: 14px;
                line-height: 17px;
                font-weight: 400;
                letter-spacing: 0.28px;
                color: #4b4849;
            }

            h3 {
                font-size: 20px;
                line-height: 24px;
                font-weight: 400;
                color: #4b4849;
            }

            h6 {
                color: $grey-dark;
                line-height: 14px;
                margin-top: 10px;
            }
        }

        &:hover {
            border-left: 10px solid var(--v-primary-base);
            box-shadow: 0 2px 7px var(--v-primary-lighten1);
        }
    }

    @media (max-width: 1260px) {
        .card--budget {
            flex-direction: column;
            justify-content: center;
            text-align: center;
            height: 180px;
            padding: 0 !important;
        }

        .card--icon {
            margin: 0 auto !important;
        }
    }
}
</style>
